import React from 'react';
import ReadMore from '../../../components/readMore/readMore';

function FeaturedSection({ featuredEmployeeSection, onIsVisibleModalFeatured }) {
    const { featuredTitle, showRepresentationText, representationText, employer } =
        featuredEmployeeSection.fields;

    return (
        <div className={'featured-section flex'}>
            <h2 className={'line-text'}>{featuredTitle}</h2>
            <div className={'employer flex'}>
                <div className={'employer-image-wrapper'}>
                    <div className={'image-shape'}>
                        <img
                            src={employer.fields.image.fields.file.url}
                            alt={employer.fields.image.fields.title}
                        />
                    </div>
                </div>
                <div className={'employer-about flex'}>
                    <div className={'employer-about-text'}>
                        <h3>{employer.fields.position}</h3>
                        <h1>{employer.fields.title}</h1>
                        {showRepresentationText ? (
                            <ReadMore>{representationText}</ReadMore>
                        ) : (
                            <ReadMore>{employer.fields.description}</ReadMore>
                        )}
                    </div>
                    <button className={'btn-route'} onClick={() => onIsVisibleModalFeatured()}>
                        View Profile
                    </button>
                </div>
            </div>
        </div>
    );
}

export default FeaturedSection;
